import { darken } from 'polished';
import { createGlobalStyle } from 'styled-components';
import { ReturnCenterDisplaySettingsResponse } from 'returnCenter-api';

export const ReactDatepicker = createGlobalStyle<{ siteSettings?: ReturnCenterDisplaySettingsResponse | null }>`
  .react-datepicker {
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    border-radius: var(--radius);
    ${({ theme }) => theme.shadows.soft};
  }

  .react-datepicker__header {
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
    border: 0;
    background: ${({ theme }) => theme.colors.fillWhite};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: ${({ theme, siteSettings }) => siteSettings?.accentThemeColor ?? theme.colors.accent};
    color: ${({ theme, siteSettings }) => siteSettings?.accentThemeTextColor ?? theme.colors.accentText};

    &:hover {
      color: ${({ theme, siteSettings }) => siteSettings?.accentThemeTextColor ?? theme.colors.accentText};
      background: ${({ theme, siteSettings }) => darken(0.08, siteSettings?.accentThemeColor ?? theme.colors.accent)}
    }
  }
`;
